module.exports = __webpack_public_path__ + "img/img12.569e39ce.png";